import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairInviteModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairInviteModalContainer" */
      './StaffGradFairInviteModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
